var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCopyIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M18.525 7.989a2.5 2.5 0 0 1 2.5 2.5v8.036a2.5 2.5 0 0 1-2.5 2.5H10.49a2.5 2.5 0 0 1-2.5-2.5V18.5a.5.5 0 0 1 1 0v.025a1.5 1.5 0 0 0 1.5 1.5h8.035a1.5 1.5 0 0 0 1.5-1.5v-8.036a1.5 1.5 0 0 0-1.5-1.5H18.5a.5.5 0 1 1 0-1zm-5.014-4.99a2.5 2.5 0 0 1 2.5 2.5v8.013a2.5 2.5 0 0 1-2.5 2.5H5.5a2.5 2.5 0 0 1-2.5-2.5V5.5a2.5 2.5 0 0 1 2.5-2.5zm-8.011 1a1.5 1.5 0 0 0-1.5 1.5v8.013a1.5 1.5 0 0 0 1.5 1.5h8.011a1.5 1.5 0 0 0 1.5-1.5V5.5a1.5 1.5 0 0 0-1.5-1.5z"
})));
export default SvgCopyIcon;